class LocationSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;

    let options = this.data.map(location => `<option value="${location.location_id}">${location.location_name}</option>`).join("")
    this.template.innerHTML =`
    <option value=null>Choose Location to Move</option>
    ${options}
    `
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder(`/admin/domains/permission/admin:view?exclude_group_id=${this.dataset.group_id}&hide_inactive=1`, false);
    this.data_binder.register(this);
    if(!this.data_binder.data){
      let res = await (fetch(`/admin/domains/permission/admin:view?exclude_group_id=${this.dataset.group_id}&hide_inactive=1`, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
          method: 'GET',
        }).catch(handleError))
      
      let data = await res.json();

      this.data_binder.data = data;
    }

    this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('location-select', LocationSelect, {extends: 'select'})